import laboratoriesActionTypes from './action-types';

export const fetchAllLabsWithFilters = payload => ({
  type: laboratoriesActionTypes.FETCH_ALL_LABS_WITH_FILTERS,
  payload,
});

export const fetchAllLabsWithFiltersSuccess = payload => ({
  type: laboratoriesActionTypes.FETCH_ALL_LABS_WITH_FILTERS_SUCCESS,
  payload,
});

export const fetchAllLabsWithFiltersFail = payload => ({
  type: laboratoriesActionTypes.FETCH_ALL_LABS_WITH_FILTERS_FAIL,
  payload,
});

export const fetchAddLabSubmission = payload => ({
  type: laboratoriesActionTypes.FETCH_ADD_LAB_SUBMISSION,
  payload,
});

export const fetchAddLabSubmissionSuccess = payload => ({
  type: laboratoriesActionTypes.FETCH_ADD_LAB_SUBMISSION_SUCCESS,
  payload,
});

export const fetchAddLabSubmissionFail = payload => ({
  type: laboratoriesActionTypes.FETCH_ADD_LAB_SUBMISSION_FAIL,
  payload,
});
